import React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { useSelector } from 'react-redux';
import useHandleTrackEvent from '@/hooks/useHandleTrackEvent';

import ThemedLogo from '@/components/ThemedLogo';

const SidebarNav = () => {
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);
  const dashboardSidebarExpanded = useSelector(
    (state) => state.uiStates.dashboardSidebarExpanded,
  );
  const handleTrackEvent = useHandleTrackEvent();

  return (
    <Box>
      <Box
        width={1}
        paddingX={2}
        paddingY={1}
        display={'flex'}
        flexDirection={'column'}
        alignItems={'start'}
        gap={2}
      >
        <Box
          sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}
        >
          <ThemedLogo variant="default" height={{ xs: 40, md: 50 }} />
        </Box>
      </Box>
      <Box paddingX={1} paddingY={1}>
        {!isLoggedIn && dashboardSidebarExpanded ? (
          <Box marginTop={2}>
            <Button
              data-trackid={'cta_sign_in_sign_up'}
              size={'small'}
              variant="outlined"
              fullWidth
              component="a"
              href="/auth/signin"
              onClick={(e) => {
                handleTrackEvent(e, 'cta_sign_in_sign_up');
              }}
            >
              Sign In / Sign Up
            </Button>
          </Box>
        ) : null}
      </Box>
    </Box>
  );
};

SidebarNav.propTypes = {
  // Add propTypes if needed
};

export default SidebarNav;
